export default class Reason {
  reason: string;

  constructor(reason: string) {
    this.reason = reason;
  }
}
